import { WprBaseViewCore } from '../view/WprBaseViewCore';
import { WprBaseObject } from '../WprBaseObject';

/**
 * デコレータ情報リスト
 */
export class WprDecoInfoList {
	// private 変数  ------------------------------------------------------------
	private m_PropertyNameList: Map<object, string[]>	= new Map<object, string[]>();	// プロパティ名称マップ
	// --------------------------------------------------------------------------

	// public メソッド	----------------------------------------------------------
	/**
	 * デコレータプロパティ情報追加
	 * @param obj 対象オブジェクト
	 * @param props プロパティ名
	 */
	public addDecoProperty(obj: WprBaseObject, props: string) {
		const cobj = obj.constructor;
		if (this.m_PropertyNameList.has(cobj) === false)
			this.m_PropertyNameList.set(cobj, new Array());
		this.m_PropertyNameList.get(cobj).push(props);
	}

	/**
	 * プロパティリスト取得
	 * @param obj 対象オブジェクト
	 * @returns プロパティリスト
	 */
	public getPropertyList(obj: WprBaseObject): string[] {
		const cobj = obj.constructor;
		if (this.m_PropertyNameList.has(cobj) === true)
			return this.m_PropertyNameList.get(cobj);
		return new Array();
	}
	// --------------------------------------------------------------------------
}